export {
  subscribeToDeviceChange,
  getAvailableInputDevices,
  unsubscribeToDeviceChange,
  destroyMediaStream,
  getUserMediaStream,
  connectMediaStreamToVideoElement,
  connectMediaStreamToAudio,
} from "./userMedia";
